let globalIndex = 0;

const assignIds = (items) => {
  return items.map(item => {
    const currentId = ++globalIndex;
    const newItem = {
      ...item,
      id: currentId,
    };

    if (item.children) {
      newItem.children = assignIds(item.children);
    }

    return newItem;
  });
};

export const roles_permissions = JSON.parse(localStorage.getItem('user_permission_data'));

export const MENUITEMS = assignIds([
  {
    menucontent: 'Dashboards,Widgets',
    Items: [
      { path: `${process.env.PUBLIC_URL}/pages/sample-page`, icon: "home", title: "Dashboard", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/appointments`, icon: "user", title: "Inquiry", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/patientList`, icon: "user", title: "Patient", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/doctor`, icon: "user", title: "Doctor", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/staff`, icon: "user", title: "Staff", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/pharmacy`, icon: "task", title: "Pharmacy", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/inventory`, icon: "others", title: "Inventory", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/accounts`, icon: "others", title: "Accounts", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      // { path: `${process.env.PUBLIC_URL}/billing`, icon: "others", title: "Billing", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      { path: `${process.env.PUBLIC_URL}/enquiryform`, icon: "others", title: "InquiryForm", type: "link", view_access: true, edit_access: true, create_access: true, delete_access: true },
      
      {
        title: "Settings",
        icon: "widget",
        type: "sub",
        menutitle: "Settings",
        menucontent: "Set settings",
        active: false,
        view_access: true, edit_access: true, create_access: true, delete_access: true,
        children: [
          { title: "Inventory Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/inventorycategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "Pharmacy Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/pharmacycategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "Staff Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/staffcategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "Doctor Department", type: "link", path: `${process.env.PUBLIC_URL}/settings/doctordepartment`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "Medical Report Type", type: "link", path: `${process.env.PUBLIC_URL}/settings/medicalreporttype`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "Diagnosis Type", type: "link", path: `${process.env.PUBLIC_URL}/settings/diagnosistype`, view_access: true, edit_access: true, create_access: true, delete_access: true },
              { title: "Diagnosis", type: "link", path: `${process.env.PUBLIC_URL}/settings/diagnosis`, view_access: true, edit_access: true, create_access: true, delete_access: true },
              { title: "Treatment Plan", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentplan`, view_access: true, edit_access: true, create_access: true, delete_access: true },
              { title: "Treatment Procedure", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentprocedure`, view_access: true, edit_access: true, create_access: true, delete_access: true },
              { title: "Treatment Method", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentmethod`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        ],
        // children: [
        //   // {
        //   //   title: "Manage Branch", type: "link", path: `${process.env.PUBLIC_URL}/settings/managebranch`, view_access: true, edit_access: true, create_access: true, delete_access: true,
        //   // },
        //   // {
        //   //   title: "Manage Time Slot", type: "link", path: `${process.env.PUBLIC_URL}/settings/slotdetails`, view_access: true, edit_access: true, create_access: true, delete_access: true,
        //   // },
        //   {
        //     title: "Treatment Settings",
        //     type: "sub",
        //     view_access: true, edit_access: true, create_access: true, delete_access: true,
        //     children: [
        //       { title: "Diagnosis Type", type: "link", path: `${process.env.PUBLIC_URL}/settings/diagnosistype`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Diagnosis", type: "link", path: `${process.env.PUBLIC_URL}/settings/diagnosis`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Treatment Plan", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentplan`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Treatment Procedure", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentprocedure`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Treatment Method", type: "link", path: `${process.env.PUBLIC_URL}/settings/treatmentmethod`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //     ],
        //   },
        //   {
        //     title: "General Category Settings",
        //     type: "sub",
        //     view_access: true, edit_access: true, create_access: true, delete_access: true,
        //     children: [
        //       { title: "Inventory Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/inventorycategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Pharmacy Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/pharmacycategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Staff Category", type: "link", path: `${process.env.PUBLIC_URL}/settings/staffcategory`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Doctor Department", type: "link", path: `${process.env.PUBLIC_URL}/settings/doctordepartment`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //       { title: "Medical Report Type", type: "link", path: `${process.env.PUBLIC_URL}/settings/medicalreporttype`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        //     ],
        //   },
        // ],
      },
      {
        title: "User Management",
        icon: "widget",
        type: "sub",
        menutitle: "User Management",
        menucontent: "Set settings",
        active: false,
        view_access: true, edit_access: true, create_access: true, delete_access: true,
        children: [
          // { title: "User Role", type: "link", path: `${process.env.PUBLIC_URL}/user/role`, view_access: true, edit_access: true, create_access: true, delete_access: true },
          { title: "User Permission", type: "link", path: `${process.env.PUBLIC_URL}/user/permission`, view_access: true, edit_access: true, create_access: true, delete_access: true },
        ],
      },
    ],
  },
  {
    Items: [],
  },
]);
